import React, { Component } from 'react';
import { Form, InputNumber, Modal } from 'antd';
import Resources from '../scripts/resources';
import Rules from '../scripts/rules';

class CreditForm extends Component {
    constructor() {
        super();

        this.state = {};

        this.formRef = React.createRef();
    }

    handleSubmit = () => {
        this.formRef.current.validateFields().then(values => {
            this.props.onSubmit(values);
        });
    }

    handleWillUnmount = () => {
        this.formRef.current.resetFields();
    }

    render() {
        const { decrease, onCancel, submitting, visible } = this.props;

        return (
            <Modal
                title={`${decrease ? Resources.decrease : Resources.increase} ${Resources.credit}`}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={onCancel}
                okText={Resources.confirm}
                cancelText={Resources.cancel}
                okButtonProps={{ loading: submitting }}
                cancelButtonProps={{ disabled: submitting }}
                width={360}>
                <Form ref={this.formRef} layout="vertical">
                    <Form.Item name="price" label={Resources.credit} rules={Rules.required}>
                        <InputNumber min={0} style={{ width: '100%' }} />
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
};

export default CreditForm;